// import Styled from 'styled-components';

// const Container = Styled.div`
//   width: 100%;
//   height: 100vh;
//   // background-image: url("${require('../../../../static/img/honda/cereza_background.jpeg')}");
//   background-size: cover;
//   background-repeat: no-repeat;
//   display: flex;
//   align-items: center;
//   .auth-side-content{
//     text-align: center;
//     margin: auto;
//   }
// `;

// const Aside = Styled.aside`
//   width: 100%;
//   height: 100vh;
//   position: relative;
//   // background-image: url("${require('../../../../static/img/honda/cereza_background.jpeg')}");
//   // background-image: url("${require('../../../../static/img/BIGBIKES.png')}");
//   background-repeat: no-repeat;
//   background-attachment: fixed;
//   background-position: left top;
//   @media only screen and (max-width: 767px){
//     height: 100%;
//   }
//   .topShape {
//     position: absolute;
//     top: 0;
//     right: 0;
//     width: 400px;
//   }
//   .bottomShape {
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     //width: 400px;
//   }
//   .auth-side-content{
//     @media only screen and (max-width: 991px){
//       h1{
//         font-size: 20px;
//       }
//     }
//     @media only screen and (max-width: 767px){
//       h1{
//         font-size: 24px;
//         margin-bottom: 28px;
//       }
//     }
//   }
// `;

// const Content = Styled.div`
//     padding: 100px;
//     @media only screen and (max-width: 1599px){
//       padding: 50px;
//     }
//     @media only screen and (max-width: 991px){
//       padding: 20px;
//     }
//     @media only screen and (max-width: 767px){
//       text-align: center;
//     }
//     .auth-content-figure{
//       @media only screen and (max-width: 1199px){
//         max-width: 420px;
//       }
//       @media only screen and (max-width: 991px){
//         max-width: 100%;
//       }
//     }
// `;

// const AuthWrapper = Styled.div`
//   height: 100%;
//   padding: 200px;
//   @media only screen and (max-width: 1599px){
//     padding: 83px;
//   }
  
//   @media only screen and (max-width: 767px){
//     text-align: center;
//   }
//   .auth-notice{
//     text-align: right;
//     font-weight: 500;
//     color: ${({ theme }) => theme['gray-color']};
//     @media only screen and (max-width: 767px){
//       text-align: center;
//       margin-bottom: 10px;
//     }
//   }
//   button{

//     &.btn-signin{
//       min-width: 185px;
      
//     }
//     &.btn-create{
//       border-radius: 8px;
//       min-width: 205px;
//     }
//     &.btn-reset{
//       border-radius: 8px;
//       min-width: 260px;
//     }
//     &.ant-btn-lg{
//       font-size: 14px;
//       font-weight: 500;
//       height: 48px;
//     }
//   }
//   .auth-contents{
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     form{
//       width: 420px;
//       h1{
//         font-size: 24px;
//         font-weight: 600;
//         margin-bottom: 45px;
//         @media only screen and (max-width: 767px){
//           margin-bottom: 28px;
//         }
//         input::placeholder{
//           color: ${({ theme }) => theme['extra-light-color']};
//         }
//       }
//       .auth-form-action{
//         margin-bottom: 20px;
//         display: flex;
//         justify-content: space-between;
//         @media only screen and (max-width: 379px){
//           flex-flow: column;
//           .forgot-pass-link{
//             margin-top: 15px;
//           }
//         }
//       }
//     }
//     #forgotPass{
//       .forgot-text{
//         margin-bottom: 25px;
//       }
//       .return-text{
//         margin-top: 35px;
//       }
//     }
//     .form-divider{
//       font-size: 13px;
//       color: ${({ theme }) => theme['gray-solid']};
//       text-align: center;
//       position: relative;
//       margin-bottom: 25px;
//       &:before{
//         content: '';
//         position: absolute;
//         width: 100%;
//         left: 0;
//         top: 50%;
//         transform: translateY(-50%);
//         z-index: 1;
//         height: 1px;
//         background: ${({ theme }) => theme['border-color-light']};
//       }
//       span{
//         background: #fff;
//         padding: 0 15px;
//         display: inline-block;
//         position: relative;
//         z-index: 2;
//       }
//     }
//     .social-login{
//       display: flex;
//       align-items: center;
//       margin: -6px;
//       @media only screen and (max-width: 767px){
//         justify-content: center;
//       }
//       &.signin-social{
//         li{
//           a{
//             box-shadow: 0 5px 15px ${({ theme }) => theme['light-color']}10;
//             background-color: #fff;
//           }
//         }
//       }
//       li{
//         padding:6px;
//         a{
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 6px;
//           height: 48px;
//           padding: 0 15px;
//           border: 1px solid ${({ theme }) => theme['border-color-light']};
//           background: ${({ theme }) => theme['bg-color-light']};
//           color: ${({ theme }) => theme['text-color']};
//           font-weight: 500;
//           @media only screen and (max-width: 379px){
//             height: 44px;
//             padding: 0 12px;
//           }
//           span:not(.anticon){
//             display: inline-block;
//             margin-left: 5px;
//           }
//           svg,
//           i{
//             width: 20px;
//             height: 20px;
//           }
//           &.google-signup,
//           &.google-signin{
//             display: flex;
//             align-items: center;
//             padding: 0 30px;
//             @media only screen and (max-width: 379px){
//               padding: 0 5px;
//             }
//             img{
//               margin-right: 8px;
//               @media only screen and (max-width: 379px){
//                 margin-right: 4px;
//               }
//             }
//           }
//           &.facebook-sign{
//             color: #475993;
//           }
//           &.twitter-sign{
//             color: #03A9F4;
//           }
//         }
//       }
//     }
//   }
//   .auth0-login{
//       margin: -6px;
//       display: flex;
//       flex-wrap: wrap;
//       a{
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 6px;
//           height: 48px;
//           padding: 0 30px;
//           background: ${({ theme }) => theme['bg-color-light']};
//           color: ${({ theme }) => theme['text-color']};
//           font-weight: 500;
//           border: 0 none;
//           border-radius: 5px;
//           margin: 6px;
//           flex: 1;
//           @media (max-width:480px){
//             flex: none;
//             width: 100%;
//           }
//       }
//     }
//   }
// `;

// export { Aside, Content, AuthWrapper,Container };
//
import Styled from 'styled-components';
import { keyframes } from 'styled-components';

const Container = Styled.div`
  width: 100%;
  height: 100vh;
  // background-image: url("${require('../../../../static/img/honda/cereza_background.jpeg')}");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  .auth-side-content{
    text-align: center;
    margin: auto;
  }
`;

const Content = Styled.div`
    // padding: 100px;
    // @media only screen and (max-width: 1599px){
    //   padding: 50px;
    // }
    // @media only screen and (max-width: 991px){
    //   padding: 20px;
    // }
    @media only screen and (max-width: 767px){
      text-align: center;
    }
    .auth-content-figure{
      @media only screen and (max-width: 1199px){
        max-width: 420px;
      }
      @media only screen and (max-width: 991px){
        max-width: 100%;
      }
    }
`;

const flicker = keyframes`
0% {
  opacity: 0;
  -webkit-transform: translateY(-20px);
  -ms-transform: translateY(-20px);
  transform: translateY(-20px);
}
100% {
  opacity: 1;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
`;

const AuthWrapper = Styled.div`
  height: 100%;
  .login-card-container {
    border-radius: 16px; 
    box-shadow: 5px 8px 24px 5px rgba(208, 216, 243, 0.6);
  }
  @media only screen and (max-width: 767px){
    text-align: center;
  }
  .login-header {
    width: 100%; 
    margin: auto;
    max-width: 450px;
    margin-bottom: 1rem;
    // position: absolute;
    // transform: translate(-50%, -50%);
    // top: -60px;
    // @media only screen and (max-width: 767px){
    //   top: -65px;
    // }
    // @media only screen and (max-width: 379px){
    //   top: -50px;
    // }
  }
  .auth-notice{
    text-align: right;
    font-weight: 500;
    color: ${({ theme }) => theme['gray-color']};
    @media only screen and (max-width: 767px){
      text-align: center;
      margin-bottom: 10px;
    }
  }
  button{
    &.btn-signin{
      width: 100%;
      border-radius: 8px;
    }
    &.btn-create{
      border-radius: 8px;
      min-width: 205px;
    }
    &.btn-reset{
      border-radius: 8px;
      min-width: 260px;
    }
    &.ant-btn-lg{
      font-size: 14px;
      font-weight: 500;
      height: 48px;
    }
  }
  .animated {
    animation-name: ${flicker};
    animation-duration: .6s;
  }
  .auth-contents{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    form{
      width: 100%;
      max-width: 450px;
      h1{
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 45px;
        @media only screen and (max-width: 767px){
          margin-bottom: 28px;
        }
        input::placeholder{
          color: ${({ theme }) => theme['extra-light-color']};
        }
      }
      .auth-form-action{
        margin-bottom: 40px;
        display: flex;
        justify-content: space-between;
        @media only screen and (max-width: 379px){
          flex-flow: column;
          .forgot-pass-link{
            margin-top: 15px;
          }
          .remember-account-pass-link {
            text-align: center;
            padding-top: 1rem;
          }
        }
        .remember-account-link {
          color: #cbcbcb;
        }
        .remember-account-pass-link {
          font-weight: 600;
          color: #b8bdbf;
          text-decoration: underline;
        }
      }
      .ant-form-item-explain.ant-form-item-explain-error {
        color: #e56161 !important;
        padding-bottom: 1rem !important; 
      }
    }
    #forgotPass{
      .forgot-text{
        margin-bottom: 25px;
      }
      .return-text{
        margin-top: 35px;
      }
    }
    .form-divider{
      font-size: 13px;
      color: ${({ theme }) => theme['gray-solid']};
      text-align: center;
      position: relative;
      margin-bottom: 25px;
      &:before{
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        height: 1px;
        background: ${({ theme }) => theme['border-color-light']};
      }
      span{
        background: #fff;
        padding: 0 15px;
        display: inline-block;
        position: relative;
        z-index: 2;
      }
    }
    .social-login{
      display: flex;
      align-items: center;
      margin: -6px;
      @media only screen and (max-width: 767px){
        justify-content: center;
      }
      &.signin-social{
        li{
          a{
            box-shadow: 0 5px 15px ${({ theme }) => theme['light-color']}10;
            background-color: #fff;
          }
        }
      }
      li{
        padding:6px;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          height: 48px;
          padding: 0 15px;
          border: 1px solid ${({ theme }) => theme['border-color-light']};
          background: ${({ theme }) => theme['bg-color-light']};
          color: ${({ theme }) => theme['text-color']};
          font-weight: 500;
          @media only screen and (max-width: 379px){
            height: 44px;
            padding: 0 12px;
          }
          span:not(.anticon){
            display: inline-block;
            margin-left: 5px;
          }
          svg,
          i{
            width: 20px;
            height: 20px;
          }
          &.google-signup,
          &.google-signin{
            display: flex;
            align-items: center;
            padding: 0 30px;
            @media only screen and (max-width: 379px){
              padding: 0 5px;
            }
            img{
              margin-right: 8px;
              @media only screen and (max-width: 379px){
                margin-right: 4px;
              }
            }
          }
          &.facebook-sign{
            color: #475993;
          }
          &.twitter-sign{
            color: #03A9F4;
          }
        }
      }
    }
  }
`;

export { Container, Content, AuthWrapper };
